import React from "react";
var __jsx = React.createElement;
import stl from "./TextImageComponent.module.css";
var TextImageComponent = function TextImageComponent(_ref) {
  var title = _ref.title,
    image = _ref.image,
    revRow = _ref.revRow,
    _ref$blueBackground = _ref.blueBackground,
    blueBackground = _ref$blueBackground === void 0 ? null : _ref$blueBackground,
    _ref$services = _ref.services,
    services = _ref$services === void 0 ? null : _ref$services,
    content = _ref.content,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(className ? className : "", " ").concat(stl.customFlexContainer, " ").concat(revRow ? stl.revRow : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.infoPart, " ").concat(services ? stl.servicesHeader : "")
  }, services ? /*#__PURE__*/React.createElement("h3", null, title) : /*#__PURE__*/React.createElement("h2", null, title), content === null || content === void 0 ? void 0 : content.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("ul", {
      key: idx
    }, /*#__PURE__*/React.createElement("li", {
      key: idx,
      className: "".concat(item.isBulltet ? stl.withBullet : "")
    }, item.text));
  })), /*#__PURE__*/React.createElement("div", {
    className: [stl.imgPart, blueBackground ? stl.trphy : "", services ? stl.grayBackground : ""].join(" ")
  }, /*#__PURE__*/React.createElement("img", {
    width: 147,
    height: 375,
    src: image,
    alt: title,
    loading: "lazy"
  }))));
};
export default TextImageComponent;